<script setup lang="ts">
defineOptions({ name: 'AuthAccount' })
import { useSso } from '../sso'
const { credentials, returnToEmail } = useSso()
</script>
<template>
  <v-sheet
    border
    class="sso-account py-1 pe-1 ps-4"
    color="background"
    rounded="pill">
    <span class="sso-account__email">{{ credentials.email }}</span>
    <v-btn
      class="sso-account__change"
      color="primary"
      height="36"
      variant="text"
      @click="returnToEmail">
      Змінити
    </v-btn>
  </v-sheet>
</template>
